import { createTheme } from "@mantine/core";

export const appFontFamily =
    '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif';

export const mantineTheme = createTheme({
    primaryColor: "green",
    defaultRadius: "sm",
    fontFamily: appFontFamily,
    headings: {
        fontFamily: appFontFamily,
        fontWeight: "600",
    },
    fontSizes: {
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
    },
    fontWeights: {
        regular: "400",
        medium: "500",
        bold: "700",
    },
    lineHeights: {
        xs: "1.4",
        sm: "1.45",
        md: "1.55",
        lg: "1.6",
        xl: "1.65",
    },
    spacing: {
        xs: "0.35rem",
        sm: "0.5rem",
        md: "0.75rem",
        lg: "1rem",
        xl: "1.5rem",
    },
});
